import settings from '@config/settings';
import { DEFAULT_MATHML_OPTIONS, DEFAULT_SANITIZE_OPTIONS } from '@kathondvla/react-shared-components/src/helpers/compilerHelper';
import { DEFAULT_OPTIONS } from '@kathondvla/react-shared-components/src/hooks/useCompiler';

/**
 * Creates compilerOptions for the Compiler component with term and markedText support.
 *
 * @param {object} params
 * @param {Array} params.terms - Array of term objects to search through
 * @param {Array} params.markExplanations - Array of markExplanation objects to search through
 * @param {object} params.termModalRef - React ref to the term modal
 * @param {function} [params.onTermClick] - Optional callback when a term is clicked
 */
export const getCompilerOptions = ({ terms, markExplanations, termModalRef, onTermClick }) => ({
  ...DEFAULT_OPTIONS,
  term: {
    compile: true,
    onClick: (key) => {
      onTermClick?.();
      const term = terms?.find((t) => t.key === key);
      if (term) {
        termModalRef.current?.open({ term });
      }
    },
  },
  markedText: {
    compile: true,
    modes: settings.hardcodings.markExplanation,
    onHover: (key, _text, setter) => {
      const explanation = markExplanations?.find((mark) => mark.key === key);
      if (explanation) setter(explanation.description);
    },
  },
  sanitizeOptions: {
    ...DEFAULT_SANITIZE_OPTIONS,
    allowedTags: [
      ...DEFAULT_SANITIZE_OPTIONS.allowedTags,
      ...DEFAULT_MATHML_OPTIONS.allowedTags,
    ],
    allowedAttributes: {
      ...DEFAULT_SANITIZE_OPTIONS.allowedAttributes,
      a: ['href', 'target', 'rel', 'class', 'data-link'],
      table: ['style', 'border', 'class'],
      td: ['colspan', 'rowspan', 'style'],
      ...DEFAULT_MATHML_OPTIONS.allowedAttributes,
    },
  }
});
